import gql from 'graphql-tag'

import { ChildFieldsFragment } from 'main/gql/child'
import { DesiredWeeklyScheduleFieldsFragment } from 'main/gql/desiredWeeklySchedule'

export const CREATE_TOUR_REQUEST_MUTATION = gql`
  mutation CreateTourRequest(
    $tourRequest: TourRequestParams!
    $desiredWeeklySchedule: DesiredWeeklyScheduleParams!
  ) {
    submitTourRequest(tourRequest: $tourRequest) {
      id
      school {
        id
      }
      child {
        ...ChildFields
      }
      availabilities {
        beginsAt
      }
    }
    upsertDesiredWeeklySchedule(desiredWeeklySchedule: $desiredWeeklySchedule) {
      ...DesiredWeeklyScheduleFields
    }
  }

  ${ChildFieldsFragment}
  ${DesiredWeeklyScheduleFieldsFragment}
`
